import { proxyClientOptions, RestfulClient, Session, StockSymbol } from '@benzinga/session';
import { SafePromise } from '@benzinga/safe-await';
import { TickerDetailsResponse } from '../../entities';
import { QuotesEnvironment } from '../../environment';
import { quotesTickersRoutes } from './routes';
import { QuotesTickersTransport } from './types';

export class QuotesTickersRestful extends RestfulClient implements QuotesTickersTransport {
  constructor(session: Session) {
    const env = session.getEnvironment(QuotesEnvironment);
    super(env.tickersUrl, session, { authorization: true }, proxyClientOptions(undefined, 'apikey'));
  }

  getTickerDetails = async (symbols: StockSymbol): SafePromise<TickerDetailsResponse> => {
    const env = this.session.getEnvironment(QuotesEnvironment);
    const path = this.routePath(quotesTickersRoutes.tickerDetails);
    const url = this.URL(path, this.withUpstreamCredentials({ symbols }, { apikey: env.tickersKey }));
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };
}
